<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'FileDisplaySimple',
})
</script>
<template>
  <div :class="bem()">
    <FileIcon :type="fileIcon" />
    <div :class="bem('name')" :title="fileName" @click="download">{{ fileName }}</div>
    <EyeOutlined :class="bem('icon')" title="预览" v-if="previewVisible" @click="handlePreview" />
    <CloseOutlined :class="bem('icon')" title="移除" v-if="closeable" @click="$emit('del')" />
  </div>
</template>

<script lang="ts" setup name="FileDisplaySimple">
import { createNamespace } from '@bd/vue3-utils'
import { fileDisplaySimpleProps } from './props'
import { CloseOutlined, EyeOutlined } from '@ant-design/icons-vue'
import { useFileDownload, useFileImagePreview, useFileMeta } from './useFile'
import { FileIcon } from '-/Base/BdIcon'
const props = defineProps(fileDisplaySimpleProps)
defineEmits(['del'])
const [_, bem] = createNamespace('FileDisplaySimple')

const { fileIcon, fileName } = useFileMeta(props.record)
const { download } = useFileDownload(props.record)
const { previewVisible, handlePreview } = useFileImagePreview(props.record)
</script>
<style lang="less">
.file-display-simple {
  display: flex;
  gap: @margin-xs;
  align-items: center;
  padding: @padding-xs @padding-sm;
  border-radius: @border-radius-base;
  background: @bg-fade-0;
  cursor: pointer;

  &__name {
    .active(@text-color);
    .text-show-row(22px);
    flex: 1;
    font-size: 14px;
  }

  &__icon {
    .active();
    cursor: pointer;
    font-size: 12px;
  }
}
</style>
